import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

export interface Tags {
    id?: string;
    name: string;
    color?: string;
    userId?: string;
}

@Injectable({ providedIn: 'root' })
export class TagsService {
    private apiUrl = environment.apiURL + 'tags'; // URL del API

    constructor(private http: HttpClient) { }

    getTags(page: number = 1, pageSize: number = 25): Observable<any> {
        return this.http.get(`${this.apiUrl}?page=${page}&pageSize=${pageSize}`);
    }
    getTag(reference: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/${reference}`);
    }
    createTag(tag: Tags): Observable<any> {
        return this.http.post(this.apiUrl + '/new', tag);
    }

    updateData(reference: string, body: any): Observable<any> {
        return this.http.put(`${this.apiUrl}/${reference}/update`, body);
    }

    deleteTag(tagId: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${tagId}/delete`);
    }
}
